import { J2Multiply } from '@e3dc-react/icons'
import { useSnackbar } from '@e3dc-react/shell/Hooks/Snackbar'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { IconButton, SxProps, Theme } from '@mui/material'
import React from 'react'
import { BANNER_SESSION_STORAGE_PREFIX, BannerKey, useBannerContext } from 'src/Libs/banners'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(theme => ({
  button: {
    color: 'inherit',
  },
}))

interface Props {
  bannerKey: BannerKey
  onRemoveSuccessMessageKey?: string
  sxCloseIcon?: SxProps<Theme>
}

/**
 * This component is a close icon button that removes a banner (temporarily).
 */
const CloseIconButton: React.FC<Props> = ({ bannerKey, onRemoveSuccessMessageKey, sxCloseIcon }) => {
  const { classes } = useStyles()
  const { removeBanner } = useBannerContext()
  const { enqueueSuccessStack } = useSnackbar()
  const { t } = useCustomTranslation()

  const handleClick = (): void => {
    sessionStorage.setItem(`${BANNER_SESSION_STORAGE_PREFIX}${bannerKey}`, 'true')
    if (onRemoveSuccessMessageKey) enqueueSuccessStack(t(onRemoveSuccessMessageKey))
    removeBanner(bannerKey)
  }

  return (
    <IconButton onClick={handleClick} className={classes.button}>
      <J2Multiply sx={sxCloseIcon} />
    </IconButton>
  )
}

export default CloseIconButton
